import { useMutation, useQueryClient } from '@tanstack/react-query'
import { inviteUser } from '../../../gateways/breadstack/userApis'
import type { InviteUserPayload } from '../../../gateways/breadstack/userApis'

interface UseUserInviteOptions {
  orgId: string
  onSuccess?: () => void
  onError?: (err: unknown) => void
}

export function useUserInvite({ orgId, onSuccess, onError }: UseUserInviteOptions) {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, InviteUserPayload>({
    mutationFn: (payload) => inviteUser(payload),
    onSuccess: () => {
      // Invalidate the user list so the new invited user appears
      // Invalidate all user-list queries for this org (any page/params combination)
      queryClient.invalidateQueries({ queryKey: ['users', orgId] })
      onSuccess?.()
    },
    onError,
  })
}
